var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 58,
    viewBox: "0 0 46 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9954 10.8494L22.7451 11.6764V35.6742L22.9954 35.917L34.4555 29.3325L22.9954 10.8494Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 10.8494L11.5396 29.3325L22.9997 35.9171V24.2693V10.8494Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9977 38.0263L22.8567 38.1934V46.7419L22.9977 47.1424L34.4648 31.4451L22.9977 38.0263Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 47.1423V38.0261L11.5396 31.4449L22.9997 47.1423Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9976 35.9171L34.4575 29.3327L22.9976 24.2695V35.9171Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5396 29.3325L22.9995 35.9171V24.2694L11.5396 29.3325Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.927,
    height: 36.3011,
    fill: "white",
    transform: "translate(11.5364 10.8494)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEther);
export default __webpack_public_path__ + "static/media/ether.38851f2161ed5d5f7a79b279ec9cd94e.svg";
export { ForwardRef as ReactComponent };